module.exports = __webpack_public_path__ + "static/img/Honor of Kings.73e18e02.png";